export default {
  //get all_SUPERADMIN QUESTIONS_BANKs
  GET_ALL_SUPERADMIN_QUESTIONS_BANK_REQUEST:
  "GET_ALL_SUPERADMIN_QUESTIONS_BANK_REQUEST",
  GET_ALL_SUPERADMIN_QUESTIONS_BANK_SUCCESS:
  "GET_ALL_SUPERADMIN_QUESTIONS_BANK_SUCCESS",
  GET_ALL_SUPERADMIN_QUESTIONS_BANK_FAIL:
  "GET_ALL_SUPERADMIN_QUESTIONS_BANK_FAIL",
  
  GET_SUPERADMIN_QUESTIONS_BANK_REQUEST:
    "GET_SUPERADMIN_QUESTIONS_BANK_REQUEST",
  GET_SUPERADMIN_QUESTIONS_BANK_SUCCESS:
    "GET_SUPERADMIN_QUESTIONS_BANK_SUCCESS",
  GET_SUPERADMIN_QUESTIONS_BANK_FAIL: "GET_SUPERADMIN_QUESTIONS_BANK_FAIL",

  //edit_SUPERADMIN QUESTIONS_BANKs
  EDIT_SUPERADMIN_QUESTION_BANK_REQUEST:
    "EDIT_SUPERADMIN_QUESTION_BANK_REQUEST",
  EDIT_SUPERADMIN_QUESTION_BANK_SUCCESS:
    "EDIT_SUPERADMIN_QUESTION_BANK_SUCCESS",
  EDIT_SUPERADMIN_QUESTION_BANK_FAIL: "EDIT_SUPERADMIN_QUESTION_BANK_FAIL",

  //create_SUPERADMIN QUESTION_BANK
  CREATE_SUPERADMIN_QUESTION_BANK_REQUEST:
    "CREATE_SUPERADMIN_QUESTION_BANK_REQUEST",
  CREATE_SUPERADMIN_QUESTION_BANK_SUCCESS:
    "CREATE_SUPERADMIN_QUESTION_BANK_SUCCESS",
  CREATE_SUPERADMIN_QUESTION_BANK_FAIL: "CREATE_SUPERADMIN_QUESTION_BANK_FAIL",

  DELETE_SUPERADMIN_QUESTION_BANK_REQUEST:
    "DELETE_SUPERADMIN_QUESTION_BANK_REQUEST",
  DELETE_SUPERADMIN_QUESTION_BANK_SUCCESS:
    "DELETE_SUPERADMIN_QUESTION_BANK_SUCCESS",
  DELETE_SUPERADMIN_QUESTION_BANK_FAIL: "DELETE_SUPERADMIN_QUESTION_BANK_FAIL",

  BOOKMARK_SUPERADMIN_QUESTION_BANK_REQUEST:
    "BOOKMARK_SUPERADMIN_QUESTION_BANK_REQUEST",
  BOOKMARK_SUPERADMIN_QUESTION_BANK_SUCCESS:
    "BOOKMARK_SUPERADMIN_QUESTION_BANK_SUCCESS",
  BOOKMARK_SUPERADMIN_QUESTION_BANK_FAIL:
    "BOOKMARK_SUPERADMIN_QUESTION_BANK_FAIL",

  GET_SUPERADMIN_QUESTION_BANK_REQUEST: "GET_SUPERADMIN_QUESTION_BANK_REQUEST",
  GET_SUPERADMIN_QUESTION_BANK_SUCCESS: "GET_SUPERADMIN_QUESTION_BANK_SUCCESS",
  GET_SUPERADMIN_QUESTION_BANK_FAIL: "GET_SUPERADMIN_QUESTION_BANK_FAIL",

  //loading
  ADD_SUPERADMIN_QUESTION_BANK_LOADING: "ADD_SUPERADMIN_QUESTION_BANK_LOADING",
  BOOKMARK_SUPERADMIN_QUESTION_BANK_LOADING:
    "BOOKMARK_SUPERADMIN_QUESTION_BANK_LOADING",
  SUSPEND_SUPERADMIN_QUESTION_BANK_LOADING:
    "SUSPEND_SUPERADMIN_QUESTION_BANK_LOADING",
};
